var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.component,{tag:"component",attrs:{"readOnly":_vm.readOnly,"printView":_vm.printView,"value-state":_vm.valueState},on:{"change":function($event){return _vm.$emit('change')}},model:{value:(_vm.commentText),callback:function ($$v) {_vm.commentText=$$v},expression:"commentText"}})
}
var staticRenderFns = []

export { render, staticRenderFns }